export interface SummarizeNoveltyInputRequest {
    /**
     * 输入文本
     */
    text: string;
    /**
     * 任务ID
     */
    task_id: string;
}

export type SummarizeNoveltyInputResponse = string;

/**
 * 总结技术要点 API
 */
export interface FtoReportInputSummaryApi {
    /**
     * 总结输入中的技术要点
     */
    summarizeNoveltyInput(data: SummarizeNoveltyInputRequest): Promise<SummarizeNoveltyInputResponse>;
}

export const FtoReportInputSummaryApi = Symbol.for('FtoReportInputSummaryApi');
